import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { queryClient } from './use-query/use-query';
import { QueryClientProvider } from '@tanstack/react-query';
import ThemeProvider from './theme/theme-provider';
import GlobalStyle from './styled-common/global-styles';
import { Provider } from 'react-redux';
import { store } from './store/store';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <GlobalStyle />
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
